var map = {
	"./2016-10-16_2048_large.png": 661,
	"./57.png": 186,
	"./BANNER.png": 160,
	"./Fashion88@2x.png": 161,
	"./Fashion92@2x.png": 162,
	"./blanket_product_03_large@2x.png": 662,
	"./blanket_product_04_large@2x.png": 663,
	"./bottom_img.png": 90,
	"./cat_img2.png": 254,
	"./cat_img3@2x.png": 176,
	"./cuddle.png": 183,
	"./fine.png": 255,
	"./home_slide_1.png": 175,
	"./images (7).png": 163,
	"./imahe.png": 664,
	"./laugh.png": 256,
	"./lifestyle.png": 173,
	"./logo.png": 665,
	"./shutterstock_433143628_2-656x438@2x.png": 666
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 253;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = 253
// module chunks = 0